// extracted by css-extract-rspack-plugin
export default {"item":"_51f9a56a","iconsWrapper":"_84d214","icon":"_1ae179b4","placeholder":"_6487aa3c","shimmer":"_c46bb23a","shimmerLoadingBackground":"_e076c912"};